import { makeStyles } from '@mui/styles';
import FormControl from 'apollo-react/components/FormControl';
import MenuItem from 'apollo-react/components/MenuItem';
import Modal from 'apollo-react/components/Modal';
import Select from 'apollo-react/components/Select';
import TextField from 'apollo-react/components/TextField';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getIsRtlLanguage } from '../../../selectors/AuthSelectors';

const useStyles = makeStyles({
  container: {
    minWidth: '300px',
  },
  muiDialogContent: {
    '& [class*="MuiDialogActions"]': {
      marginBottom: 20,
      marginTop: 5,
    },
  },
  rtlIconButton: {
    '& [class*="MuiIconButton-root"]': {
      right: 'auto',
      left: 0,
    },
  },
});

const DashboardDialog = ({ data = {}, buttonProps, onChange, children, onClose }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const isRtlLanguage = useSelector(getIsRtlLanguage);

  const { part = {}, tab = {} } = data;
  const { width, widthOption } = part;
  const { title, titleOption } = tab;

  const handleChangeTitle = (e) => {
    onChange([{ path: 'tab.title', value: e.target.value }]);
  };

  const handleChangeWidth = (e) => {
    onChange([{ path: 'part.width', value: e.target.value }]);
  };

  return (
    <Modal
      open
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={buttonProps}
      onClose={onClose}
      id="Dialog modal"
      classes={{
        paperFullWidth: classes.zoomDialogPaperFullWidth,
        paper: classNames(classes.muiDialogContent, { [classes.rtlIconButton]: isRtlLanguage }),
      }}
      title=""
    >
      {titleOption && (
        <FormControl fullWidth>
          <TextField
            name="title"
            className={classes.formWidth}
            label={translateString('Part Name')}
            defaultValue={title}
            placeholder={title}
            onChange={handleChangeTitle}
            fullWidth
          />
        </FormControl>
      )}
      {widthOption && (
        <FormControl fullWidth>
          <Select
            name="width"
            label={translateString('Part Width')}
            value={width}
            fullWidth
            canDeselect={false}
            onChange={handleChangeWidth}
          >
            <MenuItem value={4}>{`1/3 ${translateString('Width')}`}</MenuItem>
            <MenuItem value={8}>{`2/3 ${translateString('Width')}`}</MenuItem>
            <MenuItem value={12}>{translateString('Full Width')}</MenuItem>
          </Select>
        </FormControl>
      )}
      {children}
    </Modal>
  );
};

export default DashboardDialog;
